import { calculatePercentage, PIE_COLORS, PieDataItem } from '@practium/features/dashboard';
import styles from './PiePercentageChart.module.css';
interface PieLegendProps {
	items: PieDataItem[];
	total: number;
}

export const PieLegend = ({ items, total }: PieLegendProps) => {
	return (
		<div className={styles.legend}>
			{items.map((item, index) => {
				const percentage = item.percent ?? calculatePercentage(item.value, total);
				const color = item.fill ?? PIE_COLORS[index % PIE_COLORS.length];

				return (
					<div key={item.name} className={styles.legendItem}>
						<div className={styles.legendDotContainer}>
							<div className={styles.legendDot} style={{ backgroundColor: color }} />
						</div>
						<div className={styles.legendText}>
							<span className={styles.legendLabel}>{item.name}</span>
							<span className={styles.legendPercentage}>{percentage}%</span>
						</div>
					</div>
				);
			})}
		</div>
	);
};
